import hotelImage from '../../commonImages/hotel-page.jpg';
import logo from '../../commonImages/logo.png';

const LoadingScreen = ({ variant = "default" }) => {
  return (
    <div className={`relative w-full h-full loading-screen loading-screen-${variant}`}>
      {/* Background Image */}
      <img
        src={hotelImage}
        alt="Hotel"
        className="absolute inset-0 w-full h-full object-cover z-0 loading-screen-bg"
      />

      {/* Black overlay */}
      <div className="absolute inset-0 bg-black opacity-60 z-10 loading-screen-overlay" />

      {/* Top center logo */}
      <div className="relative z-20 flex justify-center w-full pt-10 loading-screen-logo-top">
        <img src={logo} alt="Logo" className="w-[53px] loading-screen-logo-img" />
      </div>

      {/* Centered text */}
      <div className="absolute inset-0 flex items-center justify-center z-20 loading-screen-center">
        <div className="flex flex-col gap-5 items-center text-white">
          <svg
  xmlns="http://www.w3.org/2000/svg"
  width="27"
  height="28"
  viewBox="0 0 27 28"
  fill="none"
  className="animate-spin loading-screen-spinner"
>
  <circle
    cx="13.5"
    cy="14"
    r="12"
    stroke="white"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeDasharray="16 8"
  />
</svg>

          <div className="text-lg font-semibold mt-0 loading-screen-text">LOADING</div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
